import packageJson from '../package.json';

export const pluginVersion: string = packageJson.version || 'UNKNOWN-VERSION';
